(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/models/wager.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/models/wager.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.bingo.models.Wager = Backbone.Model.extend({
    defaults: function() {
      return {
        wagerId: undefined,
        betAmount: undefined,
        productName: undefined,
        description: undefined,
        extraDescription: undefined
      };
    }
  });
})(Backbone, _, svs);


 })(window);